import { render, staticRenderFns } from "./MobileLayout.vue?vue&type=template&id=a1404530&scoped=true"
import script from "./MobileLayout.vue?vue&type=script&lang=js"
export * from "./MobileLayout.vue?vue&type=script&lang=js"
import style0 from "./MobileLayout.vue?vue&type=style&index=0&id=a1404530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1404530",
  null
  
)

export default component.exports